import {IProfileInfoState} from '../../../api/profileInfo/types';

export const selectProfileInfo = (state: IProfileInfoState) => state.profileInfo.data.profile;
export const selectUserRole = (state: IProfileInfoState) => state.profileInfo.data.role;
